import * as React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import MuiCheckbox, { type CheckboxProps as MuiCheckboxProps } from '@mui/material/Checkbox';

export interface CheckboxProps extends Omit<MuiCheckboxProps, 'onChange'> {
  /** react-toolbox: label text */
  label?: React.ReactNode;
  labelClassName?: string;
  /** react-toolbox: callback with checked value when changed */
  onChange?: (checked: boolean, event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Checkbox wrapper - maps react-toolbox Checkbox to MUI Checkbox
 * - `onChange(checked)` transformed from MUI's `onChange(event)`
 * - `label` wraps Checkbox in FormControlLabel
 */
const Checkbox = React.forwardRef<HTMLButtonElement, CheckboxProps>(
  ({ label, labelClassName, onChange, ...rest }, ref) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        onChange(event.target.checked, event);
      }
    };

    const checkbox = <MuiCheckbox ref={ref} onChange={handleChange} {...rest} />;

    if (label) {
      return <FormControlLabel control={checkbox} label={label} className={labelClassName} />;
    }

    return checkbox;
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
